import { render, staticRenderFns } from "./TaskGroupsAddSolversDialog.vue?vue&type=template&id=71f031f8&"
import script from "./TaskGroupsAddSolversDialog.vue?vue&type=script&lang=js&"
export * from "./TaskGroupsAddSolversDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports